var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 拖拽可以改变宽度的盒子 ")])}
var staticRenderFns = []

export { render, staticRenderFns }